module.exports = __webpack_public_path__ + "static/media/receta_new.cae15118.svg";